const doublesTriples = [
  // ── BASICS OF DOUBLES AND TRIPLES ─────────────────────────────────────────
  {
    id: "dt001",
    question: "A Doubles/Triples (T) endorsement is required to operate:",
    options: [
      "Any vehicle pulling a trailer",
      "A vehicle towing two or more trailers — doubles (two trailers) or triples (three trailers)",
      "Any combination vehicle over 60 feet",
      "A Class B vehicle towing a trailer",
    ],
    answer: 1,
    explanation: "The T endorsement is required to pull two or more trailers. Doubles (two trailers) and triples (three trailers) each require this endorsement.",
  },
  {
    id: "dt002",
    question: "Doubles and triples are more dangerous than single trailer combinations because:",
    options: [
      "They have more tires that can blow out",
      "The rearward amplification effect causes the rear trailer to sway more violently than the front unit during sudden maneuvers",
      "They are heavier and require more fuel",
      "Their engines are more powerful and harder to control",
    ],
    answer: 1,
    explanation: "Rearward amplification multiplies any front-unit movement in the rear trailers. A small steering correction at the tractor can cause violent sway in the third trailer of a triple combination.",
  },
  {
    id: "dt003",
    question: "The 'crack-the-whip' effect in triples means:",
    options: [
      "The trailer brakes are applied too hard",
      "Each successive trailer amplifies the movement of the one ahead of it — the third trailer can tip or roll during maneuvers that barely affect the tractor",
      "The fifth wheel causes wear on the kingpin",
      "The combination vehicle oversteers at low speeds",
    ],
    answer: 1,
    explanation: "The crack-the-whip effect means small inputs at the tractor become large movements at the last trailer. This makes triples especially susceptible to rollover during sudden maneuvers.",
  },
  // ── COUPLING DOUBLES AND TRIPLES ──────────────────────────────────────────
  {
    id: "dt004",
    question: "When coupling doubles, the converter dolly is used to:",
    options: [
      "Connect the tractor to the first trailer",
      "Connect the rear of the first trailer to the front of the second trailer",
      "Connect electrical cables only",
      "Adjust the height of the second trailer",
    ],
    answer: 1,
    explanation: "A converter dolly (also called a 'dolly') has a fifth wheel on top and connects to the rear of the first trailer (via pintle hook or ring), allowing the second trailer's kingpin to couple to it.",
  },
  {
    id: "dt005",
    question: "What is the proper order for coupling double trailers?",
    options: [
      "Connect second trailer first, then first trailer",
      "Connect the tractor to the first (lead) trailer → then connect the converter dolly to the rear of the first trailer → then connect the second trailer to the dolly's fifth wheel",
      "Connect all trailers simultaneously",
      "Connect the dolly first, then couple both trailers at the same time",
    ],
    answer: 1,
    explanation: "Build the double from front to rear: (1) tractor to lead trailer, (2) dolly to lead trailer rear pintle hook, (3) second trailer to dolly fifth wheel. Each connection must be fully verified before proceeding.",
  },
  {
    id: "dt006",
    question: "When uncoupling doubles, you must uncouple in what order?",
    options: [
      "First trailer, then second trailer, then dolly",
      "Rear trailer first → dolly from first trailer → first trailer from tractor (reverse of coupling order)",
      "Remove dolly first, then both trailers",
      "All at once with proper support",
    ],
    answer: 1,
    explanation: "Always uncouple from rear to front: separate the second trailer, then the dolly from the lead trailer, then the lead trailer from the tractor. This prevents equipment from rolling free.",
  },
  {
    id: "dt007",
    question: "Before uncoupling the rear trailer of a double, you must:",
    options: [
      "Only apply the rear trailer brakes",
      "Park on level ground, apply the rear trailer's parking brakes, and chock the wheels of the rear trailer before disconnecting",
      "Disconnect the air lines first",
      "Only lower the dolly landing gear",
    ],
    answer: 1,
    explanation: "Chocking and braking the rear trailer before disconnection prevents it from rolling free after the coupling is released. Never uncouple without securing the trailer first.",
  },
  {
    id: "dt008",
    question: "Safety chains on a converter dolly must be:",
    options: [
      "Attached only when on the highway",
      "Crossed under the dolly tongue and connected to the trailer so the dolly cannot fall if the pintle hook fails",
      "Attached to the tractor frame",
      "Optional if the pintle hook is new",
    ],
    answer: 1,
    explanation: "Safety chains must be crisscrossed under the dolly tongue and secured to the lead trailer to catch the dolly if the pintle hook releases. This prevents the dolly from dropping to the road.",
  },
  // ── CONVERTER DOLLY INSPECTION ─────────────────────────────────────────────
  {
    id: "dt009",
    question: "During a pre-trip inspection of a converter dolly, what must be checked?",
    options: [
      "Only tire pressure",
      "Tires, wheels, lights, air and electrical connections, the fifth wheel (lubricated and jaws working), pintle hook, safety chains, landing gear, and brakes",
      "Only the fifth wheel condition",
      "Only the air connections",
    ],
    answer: 1,
    explanation: "Every component of the dolly must be checked: tires, wheels, lights, connections, fifth wheel condition and lubrication, pintle hook security, safety chains, and brakes.",
  },
  {
    id: "dt010",
    question: "The landing gear on a converter dolly serves what purpose?",
    options: [
      "It provides extra braking on downgrades",
      "It supports the front of the dolly when it is not connected to a trailer — it prevents the dolly from tipping when uncoupled",
      "It adjusts the height of the dolly fifth wheel",
      "It is used only for parking on grades",
    ],
    answer: 1,
    explanation: "The dolly's landing gear (or support legs) holds the dolly upright when it is not coupled to a lead trailer. Without them, the dolly would tip over when uncoupled.",
  },
  // ── AIR SYSTEMS IN DOUBLES/TRIPLES ─────────────────────────────────────────
  {
    id: "dt011",
    question: "Air lines on a double or triple combination are connected:",
    options: [
      "Only from the tractor to the first trailer",
      "In series through each trailer and dolly — emergency and service lines must be properly connected at each coupling point",
      "All trailers share a single air circuit",
      "Only the lead trailer needs air lines — rear trailers use electric brakes",
    ],
    answer: 1,
    explanation: "Air must flow through the entire combination. Service and emergency lines connect from tractor to lead trailer, then via the dolly to each subsequent trailer, with each connection properly made.",
  },
  {
    id: "dt012",
    question: "If the air connection between the lead trailer and the converter dolly fails (breaks or disconnects):",
    options: [
      "Nothing happens — air brakes are only on the tractor",
      "The rear trailer spring brakes apply automatically and the tractor protection valve may close — the combination may jackknife suddenly",
      "The driver will be warned by a dashboard light",
      "Only the tractor brakes apply",
    ],
    answer: 1,
    explanation: "Loss of the emergency air line causes the rear trailer's spring brakes to apply instantly. This sudden rear braking can cause a violent jackknife or rollover. Emergency air connections are critical.",
  },
  {
    id: "dt013",
    question: "After coupling all trailers in a double combination, you should test the trailer brakes by:",
    options: [
      "Only checking that the air gauges read correctly",
      "Using the trailer hand valve and tug test on each coupling, and checking that trailer brake lights illuminate on each unit",
      "Driving slowly and pressing the foot brake",
      "Only the tractor ABS test is needed",
    ],
    answer: 1,
    explanation: "Test each coupling point: tug test, verify brake application, check brake lights. Air must flow correctly to all brake chambers on all trailers and the dolly.",
  },
  // ── DRIVING DOUBLES AND TRIPLES ────────────────────────────────────────────
  {
    id: "dt014",
    question: "When driving a double combination, the following distance should be:",
    options: [
      "The same as a single trailer combination",
      "Greater than a single trailer — more mass and the surge from two trailers increases stopping distance",
      "Shorter — doubles are more stable and stop faster",
      "The same as a car on dry pavement",
    ],
    answer: 1,
    explanation: "More mass and greater brake lag through longer air lines increase stopping distance. Doubles and triples need significantly more following distance than single trailer combinations.",
  },
  {
    id: "dt015",
    question: "When driving a triple combination vehicle, sudden maneuvers are especially dangerous because:",
    options: [
      "The engine cannot provide enough power for recovery",
      "The rearward amplification in the third trailer can cause it to roll or swing with very little provocation from the tractor",
      "Triple combinations have no ABS",
      "The coupling points are too rigid",
    ],
    answer: 1,
    explanation: "In triples, rearward amplification is extreme. A sudden lane change or steering correction that barely moves the tractor can violently whip the third trailer, causing rollover.",
  },
  {
    id: "dt016",
    question: "If the rear trailer of a double starts to sway, you should:",
    options: [
      "Brake hard to slow the sway",
      "Reduce speed gradually and smoothly — avoid any sudden steering or braking inputs that could amplify the sway",
      "Accelerate to outrun the sway",
      "Apply only the trailer brakes using the hand valve",
    ],
    answer: 1,
    explanation: "Smooth, gradual speed reduction is the correct response to trailer sway. Sudden steering or braking can amplify the oscillation and cause a rollover.",
  },
  {
    id: "dt017",
    question: "Doubles and triples have greater off-tracking than single trailer combinations because:",
    options: [
      "They are heavier",
      "Each additional trailer adds another pivot point, causing the rear trailer's wheels to cut inside the path of the front unit more severely",
      "They are longer",
      "They have more axles",
    ],
    answer: 1,
    explanation: "Off-tracking increases with each trailer in a combination. In triples, the third trailer's rear wheels may cut severely inside the path of the tractor, creating a risk of striking curbs or pedestrians.",
  },
  {
    id: "dt018",
    question: "When making a right turn in a doubles combination, you must be especially aware that:",
    options: [
      "The tractor may swing wide",
      "The rear trailer will off-track severely — its rear wheels will cut inside the turn, potentially striking objects near the inside of the curve",
      "The dolly may become uncoupled",
      "The brakes may lock on the second trailer",
    ],
    answer: 1,
    explanation: "Off-tracking in doubles is significantly greater than in a single trailer combination. Watch the mirrors and allow extra room for the rear trailer's inner path during turns.",
  },
  // ── BRAKING IN DOUBLES AND TRIPLES ─────────────────────────────────────────
  {
    id: "dt019",
    question: "Why do doubles and triples have longer stopping distances than single trailer combinations?",
    options: [
      "They have weaker brakes",
      "They are heavier and brake lag is greater because air must travel through longer lines to reach all brake chambers across multiple trailers",
      "The dolly absorbs braking force",
      "Air pressure is divided among more trailers",
    ],
    answer: 1,
    explanation: "More mass requires more force to stop. Additionally, air must travel through glad hands and lines at each coupling point, increasing brake lag to the rearmost trailer.",
  },
  {
    id: "dt020",
    question: "If the brakes on the rear trailer of a double apply unevenly or prematurely, the risk of ________ is increased.",
    options: [
      "Tire blowout",
      "Jackknife of the rear trailer (trailer swing) which can pull the entire combination out of control",
      "Fifth wheel separation",
      "Engine stall",
    ],
    answer: 1,
    explanation: "Uneven or premature rear trailer braking can lock those wheels and cause the rear trailer to swing out (jackknife). Because it is connected through the dolly, this can drag the entire combination sideways.",
  },
  // ── ROLLOVER RISK ─────────────────────────────────────────────────────────
  {
    id: "dt021",
    question: "Which part of a triple combination is most likely to roll over first?",
    options: [
      "The tractor",
      "The lead trailer",
      "The rearmost (third) trailer, due to maximum rearward amplification",
      "The converter dolly",
    ],
    answer: 2,
    explanation: "The rearmost trailer experiences the greatest amplification of any movement from the front of the combination. It has the highest rollover risk, especially in curves and lane changes.",
  },
  {
    id: "dt022",
    question: "The posted speed for curves and ramps applies to cars. For doubles and triples, a safe speed is:",
    options: [
      "The same as posted — speed limits are designed for all vehicles",
      "Much lower than the posted advisory speed — doubles and triples can roll at speeds well below car advisory speeds for the same curve",
      "Only 5 mph below the posted speed",
      "The same as a single trailer combination",
    ],
    answer: 1,
    explanation: "Posted curve advisory speeds are based on car handling. Doubles and triples — especially with liquid loads — can roll at speeds significantly below these advisory speeds.",
  },
  // ── SPECIAL REGULATIONS ───────────────────────────────────────────────────
  {
    id: "dt023",
    question: "Triple trailer combinations (three trailers) are:",
    options: [
      "Legal in all states",
      "Not permitted in all states — their use is restricted to certain western states and interstate highways where specifically permitted",
      "Only permitted for hazmat",
      "Only permitted on private roads",
    ],
    answer: 1,
    explanation: "Triple trailer combinations are not permitted in all states. They are primarily used in western states with long, straight interstate corridors. Drivers must know where triples are legal before routing.",
  },
  {
    id: "dt024",
    question: "In Massachusetts, doubles and triples operations are:",
    options: [
      "Unrestricted statewide",
      "Subject to state-specific regulations and may be restricted on certain routes — drivers should verify permits and route approvals before operating",
      "Permitted only on the turnpike",
      "Not permitted under any circumstances",
    ],
    answer: 1,
    explanation: "Massachusetts has specific regulations governing double and triple combinations. Operators must verify applicable state rules, route approvals, and any special permits required.",
  },
  {
    id: "dt025",
    question: "The maximum length for a double trailer combination on federal interstate highways (LCV — Longer Combination Vehicles) is:",
    options: [
      "48 feet total",
      "Typically two 28-foot trailers (28 + 28) — up to 57 feet per trailer in some states — plus the tractor",
      "60 feet total",
      "No federal limit exists for doubles",
    ],
    answer: 1,
    explanation: "The standard double is two 28-foot trailers. Federal law grandfathered existing LCV configurations on the interstate system. Each state may have its own restrictions within federal limits.",
  },
  // ── PRE-TRIP INSPECTION ────────────────────────────────────────────────────
  {
    id: "dt026",
    question: "A pre-trip inspection of a doubles combination includes inspecting the converter dolly's pintle hook. What should you check?",
    options: [
      "Only that the pin is present",
      "That the hook is not damaged or worn, latches fully and securely, and the locking mechanism functions properly",
      "Only that it is the correct color",
      "Only that the height is correct",
    ],
    answer: 1,
    explanation: "The pintle hook is a critical coupling point. It must fully latch and lock. A worn, damaged, or improperly latched pintle hook can release, causing the rear trailer to separate.",
  },
  {
    id: "dt027",
    question: "When inspecting the glad hands between the lead trailer and converter dolly, you should verify:",
    options: [
      "Only that they are connected",
      "That the service and emergency lines are connected correctly (not cross-connected), seals are intact, and no air leaks from the connections",
      "Only that the lines are the correct color",
      "Only that the lines are long enough",
    ],
    answer: 1,
    explanation: "Cross-connected glad hands disable trailer brakes — a fatal mistake. Check color coding (red = emergency, blue = service), verify O-ring seals are intact, and listen for leaks.",
  },
  {
    id: "dt028",
    question: "Why must you inspect every coupling point on a doubles or triples combination?",
    options: [
      "Federal law requires it only for triples",
      "Each coupling point is a potential failure point — a failure at any connection can cause trailer separation, jackknife, or loss of braking",
      "Only the rear coupling needs inspection",
      "Only the dolly-to-trailer connection needs inspection",
    ],
    answer: 1,
    explanation: "Every coupling point — tractor to lead trailer, lead trailer to dolly, dolly to rear trailer (and more for triples) — must be verified. One failed connection endangers everyone on the road.",
  },
  // ── PARKING AND SECURING ───────────────────────────────────────────────────
  {
    id: "dt029",
    question: "When parking a double combination, you must set the parking brakes on:",
    options: [
      "Only the tractor",
      "The tractor AND all trailer units — and chock the wheels of any unit that could roll independently",
      "Only the lead trailer",
      "Only the rear trailer",
    ],
    answer: 1,
    explanation: "All units in a double or triple must be secured. Each trailer is a separate vehicle that can roll independently if not secured. Apply parking brakes and chock wheels on all units.",
  },
  {
    id: "dt030",
    question: "If you must park a doubles combination on a grade, you should:",
    options: [
      "Only set the spring brakes on the tractor",
      "Set parking brakes on all units, chock all trailer wheels, and ensure each trailer is on level ground or secured against its direction of potential roll",
      "Disconnect the rear trailer on grades",
      "Only the lead trailer needs wheel chocks on grades",
    ],
    answer: 1,
    explanation: "On grades, every trailer unit must be fully secured. Spring brakes can lose holding force over time. Chocking all wheels of all units is the safest approach.",
  },
  // ── HIGH WIND AND ADVERSE CONDITIONS ─────────────────────────────────────
  {
    id: "dt031",
    question: "In high winds, doubles and triples are especially vulnerable because:",
    options: [
      "The extra couplings create vibration",
      "The additional trailer surfaces catch more wind, and rearward amplification can cause the rear trailer to sway and roll even in moderate gusts",
      "The tractor is too small to handle the wind load",
      "Air brakes become less effective in wind",
    ],
    answer: 1,
    explanation: "Multiple trailers present a large combined surface area. In crosswinds, the sway of rear trailers is amplified by the rearward amplification effect, increasing rollover risk significantly.",
  },
  {
    id: "dt032",
    question: "When crossing a bridge or exposed section of highway in a doubles or triples combination during high winds:",
    options: [
      "Maintain speed to get across quickly",
      "Reduce speed significantly — sudden gusts on open bridges can cause violent sway in rear trailers, increasing rollover risk",
      "Use the highest gear for maximum engine braking against the wind",
      "Move to the right lane only",
    ],
    answer: 1,
    explanation: "Wind gusts on exposed highways and bridges are especially dangerous for double and triple combinations. Reduce speed well before reaching open sections.",
  },
  // ── EMERGENCY PROCEDURES ──────────────────────────────────────────────────
  {
    id: "dt033",
    question: "If the rear trailer of a double begins to jackknife, the driver should:",
    options: [
      "Apply full brakes to stop the combination",
      "Immediately release all brakes and gently steer to help recover — but at highway speed, recovery from a doubles jackknife is extremely difficult",
      "Apply only the tractor brakes",
      "Accelerate to pull the trailer straight",
    ],
    answer: 1,
    explanation: "Release the brakes immediately to unlock wheels and attempt steering recovery. At highway speeds, doubles jackknife is often unrecoverable — prevention through proper braking and speed is everything.",
  },
  {
    id: "dt034",
    question: "After an accident involving a doubles or triples combination, the first step regarding the trailers is:",
    options: [
      "Uncouple the trailers immediately",
      "Secure all units — apply parking brakes and chock wheels on all trailers before attempting any other action",
      "Remove cargo from the rear trailer",
      "Check the air pressure in all trailers",
    ],
    answer: 1,
    explanation: "After any accident, the priority is preventing further movement or incidents. Secure all units before any other action (unless fire or other immediate danger requires evacuation).",
  },
  // ── WEIGHT AND FEDERAL LIMITS ─────────────────────────────────────────────
  {
    id: "dt035",
    question: "The gross vehicle weight of a double combination on interstate highways may not exceed:",
    options: [
      "90,000 lbs",
      "80,000 lbs (same federal limit as any combination vehicle)",
      "100,000 lbs for doubles",
      "60,000 lbs",
    ],
    answer: 1,
    explanation: "The federal gross vehicle weight limit is 80,000 lbs regardless of the number of trailers. Individual axle weight limits still apply to each axle group.",
  },
  {
    id: "dt036",
    question: "Because doubles and triples have more axles, they may be able to carry more total cargo weight within axle limits. However, the overall gross weight is still limited to:",
    options: [
      "However much the bridge formula allows, with no cap",
      "80,000 lbs maximum under federal law, unless a special permit is obtained",
      "60,000 lbs",
      "The weight capacity of the weakest axle multiplied by the number of axles",
    ],
    answer: 1,
    explanation: "Federal bridge law caps gross weight at 80,000 lbs regardless of axle count or spacing. Special permits are required to exceed this, and not all states allow it.",
  },
  // ── ROUTE PLANNING ────────────────────────────────────────────────────────
  {
    id: "dt037",
    question: "Before operating doubles or triples on a route, drivers should check:",
    options: [
      "Only the weather forecast",
      "State and local restrictions on LCV (Longer Combination Vehicle) operation, including restrictions on specific roads, bridges, tunnels, or time-of-day restrictions",
      "Only the truck stop locations",
      "Only the weigh station hours",
    ],
    answer: 1,
    explanation: "LCV operations are restricted in many states and on many roads. Some bridges have weight limits below 80,000 lbs. Some tunnels prohibit LCVs. Some states require special permits for doubles and triples.",
  },
  {
    id: "dt038",
    question: "When a doubles or triples operation requires a special permit, the permit must be:",
    options: [
      "Kept at the carrier's main office",
      "Carried in the vehicle at all times during the permitted operation and presented to enforcement officials upon request",
      "Only needed when crossing state lines",
      "Filed electronically — no paper copy needed",
    ],
    answer: 1,
    explanation: "Special permits for oversized or overweight operations must be in the vehicle at all times during the permitted move. Enforcement officers may request to see the permit at any time.",
  },
  {
    id: "dt039",
    question: "A driver operating triples must have:",
    options: [
      "Only a Class A CDL",
      "A Class A CDL with the T (Doubles/Triples) endorsement, plus any additional state permits required for triple trailer operation on that route",
      "A Class A CDL with both T and N endorsements",
      "Only the T endorsement — no Class A needed",
    ],
    answer: 1,
    explanation: "Class A CDL plus T endorsement are the federal minimums for operating triple trailers. Some states require additional permits, training, or approvals for triple operations.",
  },
  {
    id: "dt040",
    question: "The most critical safety habit for a doubles or triples driver is:",
    options: [
      "Keeping the fuel tank full at all times",
      "Slowing down — especially in curves, on ramps, during lane changes, and in adverse weather — because the consequences of any mistake are multiplied with each additional trailer",
      "Always driving in the right lane",
      "Keeping the cab temperature low for alertness",
    ],
    answer: 1,
    explanation: "Speed management is the single most important safety practice for doubles and triples drivers. The combination of rearward amplification and high center of gravity means that mistakes made at excessive speed are often fatal.",
  },
];

export default doublesTriples;
